cb.define([], function () {
  let AP_ap_adjustpricelist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      let self = this;
	    let gridModel = viewmodel.getGridModel();
      // viewmodel.on('beforeEdit', function (args) {
      //   console.log(viewmodel);
      //   alert(44);
      //   return false;
      // });
      console.log(viewmodel);
      viewmodel.on('beforeEdit', function (args) {
        var gridData = viewmodel.getGridModel().getData();
        var id = gridData[args.params.params.index].id;
        var data = { params: { mode: "edit", dataSource: args, id: id, parentViewModel: viewmodel }, parentViewModel: viewmodel };
        viewmodel.communication({
          payload: {
            title: '编辑角色',
            type: 'platform',
            url: 'role',
            checkReturn: true,
            data: data
          }
        });
        return false;
      });



    },
 
  }
  try {
    module.exports = AP_ap_adjustpricelist_VM_Extend;
  } catch (error) {

  }
  return AP_ap_adjustpricelist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AP/AP_ap_adjustpricelist_VM.Extend.js